module.exports = __webpack_public_path__ + "static/media/bg26.a7ebfd5f.jpg";